React = require 'react/addons'
AgeProtectedRoute = require '../../mixins/age-protected-route'
Router = require 'react-router'
Link = Router.Link
AgeVerification = require '../../actions/age-verification'
Reflux = require 'reflux'
AgeStore = require '../../stores/age-store'
NavigationStore = require '../../stores/navigation-store'
Link = Router.Link
classSet = React.addons.classSet
Navigation = require './navigation'

module.exports = React.createClass
  displayName: 'Sidebar'

  mixins: [AgeProtectedRoute, Reflux.connect(NavigationStore, 'navigationStore'), Reflux.connect(AgeStore, 'ageStatus'), Router.Navigation]

  resetAgeVerification: (event) ->
    event.preventDefault()
    AgeVerification.reset()
    @transitionTo 'age-gate'

  render: ->
    if AgeStore.ageVerification is 'true' and not(NavigationStore.hideNavigation)
      React.createElement("div", {"className": 'primary-navigation'},
        React.createElement(Navigation, null)
      )
    else
      React.createElement("span", null)



/** WEBPACK FOOTER **
 ** ./~/cjsx-loader!./src/scripts/components/shared/sidebar.cjsx
 **/